// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-down';

export const Component = () => (
  <path d='m13.86 18.284 5.124-5.125c.192-.239.432-.382.767-.382.622 0 .958.335.958 1.005 0 .24-.096.479-.288.67l-6.848 6.897-.144.096c-.24.144-.431.192-.527.192-.143 0-.382-.048-.622-.192l-.144-.096-6.848-6.897c-.192-.239-.288-.479-.288-.67 0-.67.335-1.005 1.005-1.005.336 0 .575.143.72.382l5.123 5.125V2.958c0-.623.336-.958 1.054-.958.623 0 .958.335.958.958v15.326Z' />
);

export const viewBox = '0 0 25 25';
